<template>
  <div class="detail-wrap">
    <NavHeaderBar title="会议专家劳务费信息收集" leftArrow rightArrow />
    <div class="user-info">
      <div class="user-info-title">
        <p>{{ title }}</p>
      </div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="form.name"
          name="姓名"
          label="姓名"
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
          input-align="right"
        />
        <van-field
          v-model="form.corpName"
          name="单位"
          label="单位"
          placeholder="请输入单位"
          :rules="[{ required: true, message: '请填写单位' }]"
          input-align="right"
        />

        <van-field
          readonly
          v-model="form.mobile"
          name="手机号码"
          label="手机号码"
          placeholder="请输入手机号码"
          :rules="[
            {
              pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
              message: '请填写正确的手机号'
            }
          ]"
          input-align="right"
          @touchstart.native.stop="
            () => {
              show = true;
              showCard = false;
              showCardnum = false;
            }
          "
        />
        <van-number-keyboard
          v-model="form.mobile"
          :show="show"
          :maxlength="11"
          @blur="show = false"
        />

        <van-field
          readonly
          v-model="form.idCard"
          name="身份证号"
          label="身份证号"
          placeholder="请输入身份证号"
          :rules="[{ required: true, message: '请填写身份证号' }]"
          input-align="right"
          @touchstart.native.stop="
            () => {
              show = false;
              showCard = true;
              showCardnum = false;
            }
          "
        />
        <van-number-keyboard
          :show="showCard"
          v-model="form.idCard"
          extra-key="X"
          close-button-text="完成"
          @blur="showCard = false"
        />

        <van-field
          readonly
          v-model="form.bankCard"
          name="银行卡号"
          label="银行卡号"
          placeholder="请输入银行卡号"
          :rules="[{ required: true, message: '请填写银行卡号' }]"
          input-align="right"
          @touchstart.native.stop="
            () => {
              show = false;
              showCard = false;
              showCardnum = true;
            }
          "
        />
        <van-number-keyboard
          :show="showCardnum"
          v-model="form.bankCard"
          @blur="showCardnum = false"
        />

        <van-field
          v-model="form.bankDeposit"
          name="开户银行及支行"
          label="开户银行及支行"
          placeholder="请输入开户银行及支行"
          :rules="[{ required: true, message: '请填写开户银行及支行' }]"
          input-align="right"
        />
        <van-field
          v-model="form.bankNumber"
          name="联行号"
          label="联行号"
          placeholder="请输入联行号"
          input-align="right"
        />

        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">{{
            subTitle
          }}</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import share from "@/mixins/share";
import { getEnv } from "@/config/utils";
import { queryGetUserLabor, querySaveUserLabor } from "@/config/user";
export default {
  name: "Detail",
  mixins: [share],
  data: () => ({
    show: false,
    subTitle: "提交",
    showCard: false,
    showCardnum: false,
    title: "项目名称",
    form: {
      name: "",
      projectCode: "",
      idCard: "",
      mobile: "",
      bankCard: "",
      bankDeposit: "",
      bankNumber: ""
    }
  }),
  mounted() {
    this.getlabor();
  },
  methods: {
    async onSubmit() {
      querySaveUserLabor(this.form).then(data => {
        if (data && data.success === "ok") {
          this.$toast("提交信息成功");
        }
      });
    },
    getlabor() {
      const { query } = this.$route;
      queryGetUserLabor({ projectCode: query.project }).then(data => {
        if (data && data.success === "ok") {
          this.title = data.data.projectName;
          if (data.data.bankCard) {
            this.subTitle = "修改";
          }
          this.form = {
            ...data.data
          };

          // 分享
          if (getEnv() !== "h5") {
            this.onShare({
              link:
                window.location.href.split("?")[0] +
                "?project=" +
                query.project,
              title: data.data.projectName + "劳务费信息表",
              imgUrl:
                "https://ydkoss.usfsoft.com/fengmian/zhuanjiafeitianbao.png",
              desc:
                "尊敬的专家您好，请尽快填写您的劳务费信息表单，以便会务组办理！"
            });
          }
        } else {
          this.$toast.fail("获取劳务费信息失败");
        }
      });
    }
  }
};
</script>

<style lang="scss">
.user-info {
  padding-top: 46px;
  .user-info-title {
    display: flex;
    justify-content: center;
    font-size: 14px;
    padding: 15px;
    color: #333;
    border: 1px solid #ebedf0;
  }

  .van-field__error-message {
    text-align: right;
  }
}
</style>
